import { data } from '../../svg/Swap/data';
import { makeIcon } from '../makeIcon';

export const Swap = makeIcon(data, 'swap', 'Swap');

export default Swap;
